export function paymentRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "FETCH_PAYMENTS_START":           
        case "LINK_PAYMENTS_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "FETCH_PAYMENTS_FULFILLED":           
        case "LINK_PAYMENTS_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "FETCH_PAYMENTS_ERROR":
            return {
                ...state
            }
        case "LINK_PAYMENTS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}